import { render } from "./MinisterioMulheres.vue?vue&type=template&id=785a6ad7&scoped=true&lang=pug"
import script from "./MinisterioMulheres.vue?vue&type=script&setup=true&lang=js"
export * from "./MinisterioMulheres.vue?vue&type=script&setup=true&lang=js"

import "./MinisterioMulheres.vue?vue&type=style&index=0&id=785a6ad7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785a6ad7"]])

export default __exports__